<template>
    <div class="accountInformation" @click.stop="() => { }">
        <div class="content">
            <!-- <img :src="userInformation.avatar" class="avatar"> -->
            <div class="avatar"
                :style="{ background: userInformation.avatar ? 'url(' + userInformation.avatar + ')' : '#ccc', backgroundSize: '100%' }"
                @click="">
                <input type="file" @change="uploadAvatar">
            </div>
            <h4>上传头像</h4>
            <div class="form-row">
                <label class="form-label">昵称：</label>
                <input v-model="userInformation.nickname" placeholder="请输入昵称">
            </div>

            <div class="form-row">
                <label class="form-label">用户介绍：</label>
                <textarea name="mark" v-model="userInformation.mark" placeholder="请输入介绍"></textarea>
            </div>
            <!-- <el-button type="primary" @click="update"style="width: 200rem;height: 40rem; align-self: center; border-radius: 5rem;margin-top: 25rem;">确认修改</el-button> -->
            <span class="auth-btn" @click="update" style="margin-top: 25rem; align-self: center;">确认修改</span>
        </div>
    </div>
</template>

<script setup>
import { http } from '@/request/http'
import { onMounted, reactive } from 'vue'
import { client } from '@/request/oss'
import { toRaw } from 'vue'
import { useStore } from 'vuex'
import { showNotify, closeNotify } from 'vant';
const store = useStore()
const userInformation = reactive({
    nickname: '',
    avatar: '',
    mark: ''
})
const $emit = defineEmits(['close'])

const update = () => {
    http.put('/app-api/member/user/update', toRaw(userInformation)).then(res => {
        showNotify({
            message: '修改成功',
            type: 'success'
        })
        $emit('close')
        store.dispatch('getUserInfo')
    })
}

const uploadAvatar = e => {
    const file = e.target.files[0]
    const extName = file.name.slice(file.name.lastIndexOf('.'))
    client.setBucket('dfsk-3d')
    client.put(`cover/${Date.now() + extName}`, file).then(result => {
        userInformation.avatar = result.url
    })
}

onMounted(() => {
    http.get('/app-api/member/user/get').then(res => {
        Object.assign(userInformation, res)
    })
})

</script>

<style scoped lang="scss">
.auth-btn {
    width: 200rem;
    height: 40rem;
    background-color: #000000;
    display: flex;
    justify-content: center;
    align-items: center;
    font-size: 14rem;
    font-weight: 500;
    color: rgba(255, 255, 255, 1);
}

.accountInformation {
    background-color: #fff;
    border-radius: 10rem;
    overflow: hidden;
    padding-bottom: 20rem;
}

header {
    height: 70rem;
    display: flex;
    justify-content: center;
    align-items: center;
    font-size: 18rem;
    font-weight: 500;
    letter-spacing: 0px;
    line-height: 26.06px;
    color: rgba(0, 0, 0, 1);
    border-bottom: 1px solid rgba(245, 246, 250, 1);
}

.content {
    display: flex;
    flex-direction: column;
    width: 100%;
    border-radius: 9.78rem;
    padding: 24rem 25rem 10rem;

    .avatar {
        width: 60rem;
        height: 60rem;
        border-radius: 30rem;
        align-self: center;
        background-size: 100% 100%;

        input {
            width: 100%;
            height: 100%;
            opacity: 0;
            cursor: pointer;
        }
    }

    h4 {
        align-self: center;
    }

    .form-row {
        display: flex;
        align-items: flex-start;
        margin-top: 28rem;

        input {
            height: 32rem;
            line-height: 32rem;
            border: 1px solid #E5E5E5;
            font-size: 14rem;
            width: 100%;
            padding: 0 10rem;
        }

        textarea {
            width: 100%;
            height: 120rem;
            line-height: 32rem;
            border: 1px solid #E5E5E5;
            font-size: 14rem;
            padding: 0 10rem;
        }
    }

    .form-label {
        width: 70rem;
        flex-shrink: 0;
        line-height: 32rem;
        margin-right: 10rem;
        font-size: 14rem;
    }
}
</style>